import React from 'react';
import { IntlMessagesProvider } from '@atlaskit/intl-messages-provider';
import messages from '../../../i18n/en';
import { fetchMessagesForLocale } from './fetch-messages-for-locale';
export var BSCIntlProvider = function BSCIntlProvider(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(IntlMessagesProvider, {
    defaultMessages: messages,
    loaderFn: fetchMessagesForLocale
  }, children);
};